module.exports = __webpack_public_path__ + "static/media/bg10.628e19f9.jpg";